import { React, FC, useContext} from 'external/react'
import {styled} from 'external/material'

import { TeacherContext } from 'teacher/context'
import { DailyPlanning } from './DailyPlanning'


const StyledDailyPlanning = styled('div')(dailyPlanningStyles as any)

type DailyPlanningProps = {
  lastItemRef: any
} 

const DailyPlans: FC<DailyPlanningProps> = (props) => {

  const {lastItemRef} = props
  const {translate, newPlan} = useContext(TeacherContext) as any

  return (
    <StyledDailyPlanning>
      {newPlan.content?.dailyPlanning?.map((_:any, index:number, arr:any[]) => {
          const isLast = index === arr.length - 1
          return <DailyPlanning refu={isLast ? lastItemRef : null} id={index} title={translate(`plannind-rd-daily-planning-title`,{n: index + 1})} key={index} />
      })}
    </StyledDailyPlanning>
  )
}

function dailyPlanningStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxSizing: 'border-box',
        padding: 0
    }
}

export { DailyPlans as default }